(ns minorodata.file-ingest.api
  (:require [re-posh.core :as re-posh]
            [mold-http.core :refer [reg-event-http]]
            [minorodata.file-ingest.model :refer [->ingest-error ->ingest-file ->ingest-preview-data ->ingest-result ->ingest-selected-sheet ->ingest-tables]]))


;; =============================================================================
;; Upload a file
;; =============================================================================

(defn file-upload-request
  [_ [file]]
  (let [form-data (doto (js/FormData.)
                    (.append "file" file))]
    {:http-xhrio
     {:url    "/api/file-ingest/upload"
      :method :post
      :body   form-data}}))

(defn file-upload-callback
  [_ [error res]]
  (if error
    {:dispatch-n [[:ingest-error/add (->ingest-error
                                      {:step         :upload-file
                                       :show-loader? false
                                       :msg          (or (get-in error [:response :error])
                                                         (get error :failure))})]]}
    (let [{:keys [path bucket]} res]
      {:dispatch-n [[:ingest-error/delete]
                    [:file-ingest.events/set-uploaded-file bucket path]]})))

(reg-event-http
 :file-ingest.api/file-upload
 file-upload-request
 file-upload-callback)


;; =============================================================================
;; Load list of sheets
;; =============================================================================


(defn fetch-sheets-request
  [_ [path]]
  {:http-xhrio
   {:url    "/api/file-ingest/sheet-names"
    :method :post
    :params {:path path}}})

(defn fetch-sheets-callback
  [_ [error res]]
  (if error
    {:dispatch-n [[:app.events/add-snack :error "Unable to fetch list of sheets"]
                  [:app.api/log :error (str "Failed to load list of sheets: " error)]
                  [:ingest-preview-data/add (->ingest-preview-data {:data []})]]}
    (let [{:keys [sheet-names]} res]

      (if (> (count sheet-names) 1)
        {:dispatch-n [[:ingest-preview-data/delete]
                      [:ingest-file/update (->ingest-file {:sheet-names sheet-names})]
                      [:file-ingest.events/set-wizard-step :select-sheet]]}

        {:dispatch-n [[:ingest-preview-data/delete]
                      [:ingest-file/update (->ingest-file {:sheet-names sheet-names})]
                      [:ingest-selected-sheet/add (->ingest-selected-sheet
                                                   {:name (first sheet-names)})]
                      [:file-ingest.events/set-wizard-step :preview-data]]}))))

(reg-event-http
 :file-ingest.api/fetch-sheets
 fetch-sheets-request
 fetch-sheets-callback)


;; =============================================================================
;; Load preview rows
;; =============================================================================

(defn preview-data-request
  [_ _]
  (let [sheet-name @(re-posh/subscribe [:ingest-selected-sheet/prop :ingest-selected-sheet/name])
        path       @(re-posh/subscribe [:ingest-file/prop :ingest-file/path])]
    {:http-xhrio
     {:url    "/api/file-ingest/preview"
      :method :post
      :params {:path       path
               :sheet-name sheet-name}}}))


(defn preview-data-callback
  [_ [error res]]

  (if error
    (let [error-message (get-in error [:response :error] "Failed to process input")]
      {:dispatch-n [[:app.events/add-snack :error "Unable to fetch preview data"]
                    [:app.api/log :error (str "Failed to load preview data: " error)]
                    [:ingest-preview-data/add
                     (->ingest-preview-data
                      {:data                  []
                       :preview-error?        true
                       :preview-error-message error-message})]
                    [:file-ingest.events/set-wizard-step :preview-data-error]]})
    (let [{:keys [preview-rows]} res
          preview-data (->ingest-preview-data
                        {:data                  preview-rows
                         :preview-error?        false
                         :preview-error-message ""})]
      {:dispatch-n [[:ingest-preview-data/delete]
                    [:ingest-preview-data/add preview-data]]})))

(reg-event-http
 :file-ingest.api/preview-data
 preview-data-request
 preview-data-callback)


;; =============================================================================
;; Load ingest tables
;; =============================================================================

(defn load-ingest-tables-request
  [_ _]
  {:http-xhrio
   {:url "/api/ingest-tables"}})

(defn load-ingest-tables-callback
  [_ [error res]]
  (if error
    {:dispatch-n [[:app.events/add-snack :error "Unable to fetch ingest tables"]
                  [:app.api/log :error (str "Failed to load ingest tables: " error)]]}
    {:dispatch [:ingest-tables/add (->ingest-tables {:tables res})]}))

(reg-event-http
 :file-ingest.api/load-ingest-tables
 load-ingest-tables-request
 load-ingest-tables-callback)


;; =============================================================================
;; Import data
;; =============================================================================

(defn import-data-request
  [_]
  (let [table-params @(re-posh/subscribe [:ingest-table-params/pull])
        {:ingest-table-params/keys [type table-name]} table-params

        sheet-name @(re-posh/subscribe [:ingest-selected-sheet/prop :ingest-selected-sheet/name])
        path       @(re-posh/subscribe [:ingest-file/prop :ingest-file/path])
        bucket     @(re-posh/subscribe [:ingest-file/prop :ingest-file/bucket])

        header-row @(re-posh/subscribe [:ingest-header-row/prop :ingest-header-row/header-idx])

        ingest-cols @(re-posh/subscribe [:ingest-selected-columns/pull])
        {:ingest-selected-columns/keys [columns]} ingest-cols

        params (cond-> {:type        type
                        :table       table-name
                        :bucket      bucket
                        :path        path
                        :sheet-name  sheet-name
                        :drop-header (not (nil? header-row))}
                 (= type :new) (assoc :columns columns))]
    {:http-xhrio
     {:method :post
      :url "/api/file-ingest"
      :params params}}))


(defn import-data-callback
  [_ [error res]]
  (if error
    (let [reason (get-in error [:response :error])]
      {:dispatch [:ingest-result/add (->ingest-result
                                      {:result :fail
                                       :reason reason})]})
    {:dispatch [:ingest-result/add (-> res
                                       (assoc :result :success)
                                       ->ingest-result)]}))

(reg-event-http
 :file-ingest.api/import-data
 import-data-request
 import-data-callback)
